import { styled } from '@mui/material/styles'

/**STYLE */
import { scale } from '../../constants/scale'

/**
 * ยกมาจาก App.tsx ตอนแยก AppShell ออกมาเป็น layout ครอบ Switch
 * เนื้อ style เหมือนเดิมทุกบรรทัด — แยกไฟล์เพื่อเลี่ยง circular import (App -> AppShell -> App)
 */
export const ContainerComponent = styled('div')(({ theme }) => ({
  '&.no-appBar': {
    top: '0 !important',
    height: '100vh !important',
  },
  // overflow:'auto',

}))

export const ContainerMenu = styled('div')(({ theme }) => ({
  position: 'relative',
  width: '0',
  zIndex: 1200,
  // [theme.breakpoints.down("md")]: {
  //   width: "100%",
  //   maxWidth: `calc(${scale.sidebarSize})`,
  //   // maxWidth: '248px'
  // },
  [theme.breakpoints.up("md")]: {
    width: "100%",
    maxWidth: `calc(${scale.sidebarSize})`,
    // maxWidth: '248px',
  },
  [theme.breakpoints.up("lg")]: {
    width: "100%",
    // maxWidth: `calc(${scale.sidebarSize})`,
    maxWidth: '248px',
  },
  [theme.breakpoints.up("xl")]: {
    width: "100%",
    // maxWidth: scale.sidebarSize,
    maxWidth: '248px'
  },
}))

export const ContainerContent = styled("div")<{ appBar?: boolean }>(({ theme, appBar }) => ({
  width: "100%",
  /**
   * ต้องหักความสูง header จริงตาม breakpoint (ดู AppBarMain ใน component/header/header.tsx)
   * ไม่ใช่ค่าคงที่ 64px — header จริงคือ 96/80/72/56px ทำให้กล่องนี้สูงเกินที่ว่างจริง 8-32px
   * ส่วนที่เกินถูกดันลงใต้ขอบจอ และ body มี overflow:hidden จึงเลื่อนลงไปดูไม่ได้
   * (อาการ: แถวล่างสุดของหน้า เช่น pagination ของตาราง โดนตัดครึ่งและ scroll ต่อไม่ได้)
   */
  height: `calc(100vh - ${scale.navbarHeight})`,
  overflow: 'auto',
  [theme.breakpoints.down('xl')]: {
    height: `calc(100vh - (${scale.navbarHeight} - 1rem))`
  },
  [theme.breakpoints.down('lg')]: {
    height: `calc(100vh - (${scale.navbarHeight} - 1.5rem))`
  },
  [theme.breakpoints.down('sm')]: {
    height: `calc(100vh - (${scale.navbarHeight} - 2.5rem))`
  },
  [theme.breakpoints.up("md")]: {
    maxWidth: `calc(100% - ${appBar ? scale.sidebarSize : 0})`,
  },
  "> div": {
    width: "100% !important",
    display: "block !important",
    minHeight: "unset !important",
    height: 'auto',
    border: "none !important",
    boxShadow: "none important",
    marginTop: "0 !important",
  },
  "& .card-header": {
    width: "100% !important",
    height: "auto !important",
  },
}))
